import reportVocabulary from '../utils/vocabulary.js'
import Vue from 'vue'
const mixin = {
    data(){
        return {
            latest_report_id: 0,
            is_reload_needed: false
        }
    },
    computed: {
        line_item_descriptions() {
			console.log(this.$store.getters.line_item_descriptions);
            return this.$store.getters.line_item_descriptions
        },
        report_vocabulary(){
            let self = this
            if(!self.report.report_language)
                return [];
            let res = {};
            for (var key in reportVocabulary) {
                let val = reportVocabulary[key][self.report.report_language]
                if(val)
                    res[key] = val
            }

            return res
        },
        report() {
            return this.$store.getters.report
        },
        car() {
            return this.$store.getters.car
        },
        clients() {
            let self = this;
            return self.$store.getters.clients.filter((v)=>{
                if(self.isRentalReport() || self.isEuropcarReport() || self.isAldReport()){
                    if(v.name == "Autotaksering AS")
                        return v
                    else
                        return 0
                }

                return v;
            })
        },
        client: {
            get: function () {
                return this.getClientById(this.report.id_client)
            },
            set: function (lc) {
                this.$store.dispatch('setReportClient',lc ? lc.id : null)
            }
        },
        grouped_sections(){
            var groups = [];
            this.sections.forEach(function(item, index, array) {
                item.index = index+1;
                if(!groups[item.sectionGroup])
                    groups[item.sectionGroup] = [item];
                else
                    groups[item.sectionGroup].push(item)
            });
            return groups.filter(function(v) { return v; });
        },
        grouped_items_replies(){
            var replies = [];
            var res = [];
            this.report_items_replies.forEach(function(item, index, array) {

                if(item.title) {
                    if (!replies[item.title])
                        replies[item.title] = [];
                    replies[item.title].push(item)
                }else{
                    res.push(item)
                }

            });

            for(var index in replies) {
                res.push({title: index, content:''})
                res = res.concat(replies[index])
            }

            return res;
        },
        items_replies(){
            return this.report_items_replies.map((item, idx) => {
                return item.content;
            });
        },
        sections() {
            var items = []
            
            var sectionIndex = 1;
	        var itemIndex = 1;
	      

            this.report_items.forEach(function(item, index, array) {

                if(item.caption == 'Skade' && item.section_caption=="Takstpunkter" && !item.id_report_item){
                    item.caption = 'Ekstra bilde'
                }
	            
                if(!items[item.id_report_section]) { 
	                items[item.id_report_section] = {
	                    id: item.id_report_section,
	                    //caption:  (item.section_group / 10 + 1 ) + "." + sectionIndex + "." + itemIndex + " " + item.category_caption,
	                    caption: item.section_caption,
	                    //captionIndex: (item.section_group / 10 + 1 ) + "." + sectionIndex,
	                    categories: [],
	                    sectionGroup: item.section_group,
	                    sectionViewOrder: item.section_view_order,
	                    inspection_off: item.section_inspection_off   
	                    
                	}
                	//console.log( (item.section_group / 10 + 1 ) + "." + sectionIndex + " : " + item.section_caption );
                	itemIndex++;
                }

                if(!items[item.id_report_section]['categories'][item.id_report_category]) {
	                items[item.id_report_section]['categories'][item.id_report_category] = {
	                    id: item.id_report_category,
	                    caption: item.category_caption,
	                    //caption:  (item.section_group / 10 + 1 ) + "." + sectionIndex + "." + itemIndex + " " + item.category_caption,                    
	                    items: []
	                }
	                sectionIndex++;
                }

                items[item.id_report_section]['categories'][item.id_report_category]['items'].push(item)
            })
            items = items.filter(function(v) { return v; })
            items.forEach(function(item, index, array) {
                item.categories = item.categories.filter(function(v) {
                    if(v) {
                        v.items.sort((a, b)=>{
                            a = parseInt(a.id_report_item);
                            b = parseInt(b.id_report_item);
                            a = a ? a : 0;
                            b = b ? b : 0;
                            return a-b;
                        })

                        v.items.sort((a, b)=>{
                            a = parseInt(a.priority);
                            b = parseInt(b.priority);
                            a = a ? a : 0;
                            b = b ? b : 0;
                            return b-a;
                        })

                    }
                    return v;
                })
            })

            items.sort(function(a, b) {
                    return parseInt(a.sectionViewOrder) - parseInt(b.sectionViewOrder);
                });

					
			
			var sectionone = 1;
			var sectiontwo = 1;
			var sectionthree= 1;
			var captionIndex = "";
			
			items.forEach(function(item, index, array) {
				if ( items[index].sectionGroup == 0 ){
					captionIndex = "1." + sectionone;
					sectionone++;					
				}
				else if (items[index].sectionGroup == 10) {
					captionIndex = "2." + sectiontwo;
					sectiontwo++;
				}
				else if (items[index].sectionGroup == 20) {
					captionIndex = "3." + sectionthree;
					sectionthree++;
				}
				items[index].captionIndex = captionIndex; 
				items[index].captionNumbered = captionIndex + " " + items[index].caption; 
				
				
				var partIndex = 1;
							
				if (items[index].categories[0]) {
					items[index].categories[0].items.forEach(function(item, indexi, array) {
					
						items[index].categories[0].items[indexi].caption_numbered = captionIndex + "." + partIndex;
						partIndex++;
					})
				}
				
				
				
			})
            return items
        },
        section() {
            return this.sections[this.$route.params.num-1]
        },
        tires_items(){
            return this.report_items.filter((item)=>{
                return item.section_caption == "Dekk og felg" && item.extra_value
            })
        },
        summer_tires_items(){
            return this.tires_items.filter((item)=>{
                return item.caption.indexOf("Sommer") != -1
            })
        },
        winter_tires_items(){
            return this.tires_items.filter((item)=>{
                return item.caption.indexOf("Vinter") != -1
            })
        },
        report_items(){
            return this.$store.getters.report_items
        },
        report_items_replies(){
            return this.$store.getters.report_items_replies
        },
        itemsStats(){
			console.log('calculate items stats');

            var items = [0,0,0,0]
            this.$store.getters.report_items.forEach(function(item, index, array) {
                var estimate = parseFloat(item.estimate);

				console.log(item);

                estimate = estimate ? estimate : 0;

				if (item.caption !== "Dokumentasjon") {
					switch (parseInt(item.state)) {
						case 1:
							items[0] += 1
							break
						case 0:
							items[1] += 1
							break
						case -1:
							items[2] += 1
							items[3] += estimate
							break
					}
				}
            })
            return items
        },
        damageSections(){
            var items = []
            this.$store.getters.report_items.forEach(function(item, index, array) {
                if(!items[item.id_report_section]) items[item.id_report_section] = {
                    caption: item.section_caption,
                    items: []
                }

				console.log(item);

				// || !item.state
                if(parseInt(item.state) < 1 || (item.caption === 'Dokumentasjon' && item.images && item.images.length)) {
	                items[item.id_report_section]['items'].push(item)
                }

            })
            items = items.filter(function(section) { return section.items.length; })

            return items
        },
        report_items_menu(){
            var items = []
            var self = this

            if(!self.sections.length || ['report-section','report-contact','report-images','report'].indexOf(this.$route.name) == -1)
                return items

            items.push({
                title: '1. Kontaktinfo',
                link: self.$router.resolve({
                    name: 'report-contact',
                    params:{
                        id: self.$route.params.id
                    }
                }).href,
                icon: 'assignment_ind'
            })
            self.grouped_sections.forEach(function(group, index, array) {
                items = items.concat(group.map((item, idx) => {
	                
	                if (item.caption == "Takstpunkter") {
		                return {
	                        title: (index+1) + '.' + (idx+1) + ' ' + item.caption,
	                        link: self.$router.resolve({
	                            name: 'report-images',
	                            params:{
	                                id: self.$route.params.id,
	                                num: item.index
	                            }
	                        }).href,
	                        icon: 'photo_camera'
	                    }
	                }
	                else {
	                    return {
	                        title: (index+1) + '.' + (idx+1) + ' ' + item.caption,
	                        link: self.$router.resolve({
	                            name: 'report-section',
	                            params:{
	                                id: self.$route.params.id,
	                                num: item.index
	                            }
	                        }).href,
	                        icon: 'assignment'
	                    }
                    }
                }))
            })
            //console.log(self.grouped_sections);

            /*items = items.concat(self.sections.map((item, idx) => {
                return {
                    title: (idx+2) + '. ' + item.caption,
                    link: self.$router.resolve({
                        name: 'report-section',
                        params:{
                            id: self.$route.params.id,
                            num: idx+1
                        }
                    }).href,
                    icon: 'assignment'
                }
            }))*/

            items.push({
                title: 'Rapport',
                link: self.$router.resolve({
                    name: 'report',
                    params:{
                        id: self.$route.params.id
                    }
                }).href,
                icon: 'assessment'
            })
            console.log("ITEMS:");
            console.log(items);
            return items
        }
    },
    methods: {
        isReportClient(user_login){
            return this.client && this.client.user_login == user_login;
        },
        isRegularReport(){
            return this.report.id_report_type == 1
        },
        isRentalReport(){
            return this.report.id_report_type == 2
        },
        isApiReport(){
            return this.report.id_report_type == 3
        },
        isEuropcarReport(){
            return this.report.id_report_type == 4
        },
        isRentalCheckReport(){
            return this.report.id_report_type == 5
        },
        isAldReport(){
            return this.report.id_report_type == 6
        },
	    isEuropcarReportDenmark(){
		    return this.report.id_report_type == 7
	    },
        isWithoutPrice(){
            return this.report.without_price
        },
        isServiceHistorySection(){
            return this.isServiceHistory() || this.report.service_history_description
        },
        isServiceHistory(){
            let hasServiceHistory = this.report.service_history
            if(hasServiceHistory){
                let history = this.report.service_history.filter((v)=>{
                    return v[0] || v[1];
                })
                hasServiceHistory = history.length
            }
            return hasServiceHistory
        },
        isReportPage(){
            return ['report-section', 'report-images', 'report-contact', 'reports-code', 'report'].indexOf(this.$route.name) != -1
        },
        translate($key, param){
            let res;
            if(this.report_vocabulary[$key]){
                res = this.report_vocabulary[$key]
            }else{
                res = $key;
            }
            if(param)
                res = res.replace('%s', param)
            return res;
        }
    }
}
export default mixin


// WEBPACK FOOTER //
// ./reports/assets/src/mixins/reportValues.js